import { render, staticRenderFns } from "./RunCardNotificationsRow.vue?vue&type=template&id=1355f4a1&scoped=true&"
import script from "./RunCardNotificationsRow.vue?vue&type=script&lang=ts&"
export * from "./RunCardNotificationsRow.vue?vue&type=script&lang=ts&"
import style0 from "./RunCardNotificationsRow.vue?vue&type=style&index=0&id=1355f4a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1355f4a1",
  null
  
)

export default component.exports